var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcSignout = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f68b5;}.b,.c,.d{fill:none;}.c,.d{stroke:#fff;stroke-width:1.5px;}.c{stroke-linejoin:round;}.d{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1652 -93)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 17,
  cy: 17,
  r: 17,
  transform: "translate(1652 93)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1162 -19.871)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 24,
  height: 24,
  transform: "translate(495 117.871)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(500.266 122.564)"
}, /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M516.022,130.68V127.8H504.788v15.446h11.233v-3.012",
  transform: "translate(-504.788 -127.802)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(505.543 127.892)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M511.017,135.5h9.127",
  transform: "translate(-511.017 -133.105)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M0,0H4.213",
  transform: "matrix(0.819, 0.574, -0.574, 0.819, 7.261, 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M0,0H4.213",
  transform: "matrix(0.819, -0.574, 0.574, 0.819, 7.261, 4.811)"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSignout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_signout.b897260abba97c67b3d24862db60d4ed.svg";